<template>
  <div class="page-content">
    <!-- Header -->
    <div class="page-header">
      <div>
        <BreadcrumbComponent :items="items" />
        <h1 class="page-title">Rapport de Retours</h1>
      </div>
    </div>

    <PreloaderComponent :enable="enable" />

    <div v-if="enable">
      <!-- Filters -->
      <v-card flat class="filter-card mb-4">
        <v-card-text class="py-3">
          <v-row align="center" dense>
            <v-col cols="12" sm="6" md="2">
              <v-select
                :items="stores"
                item-value="id"
                item-text="name"
                placeholder="Emplacement"
                prepend-inner-icon="mdi-store-outline"
                v-model="store_id"
                outlined
                dense
                hide-details
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-select
                :items="users"
                item-value="id"
                item-text="full_name"
                placeholder="Agent"
                v-model="user_id"
                outlined
                dense
                hide-details
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="2">
              <v-select
                :items="statuses"
                item-value="id"
                item-text="label"
                placeholder="Statut"
                v-model="status"
                outlined
                dense
                hide-details
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="2">
              <v-text-field
                v-model="sale_number"
                placeholder="# de Retour"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="auto">
              <div class="d-flex gap-2">
                <v-btn color="secondary" depressed small @click="filter" :loading="loading" class="mr-1">
                  <v-icon small>mdi-check</v-icon>
                </v-btn>
                <v-btn outlined small @click="reset" :loading="loading" class="mr-1">
                  <v-icon small>mdi-refresh</v-icon>
                </v-btn>
                <v-btn color="error" outlined small @click="exportPDF" class="mr-1">
                  <v-icon small>mdi-file-pdf-box</v-icon>
                </v-btn>
                <v-btn color="success" outlined small @click="exportExcel">
                  <v-icon small>mdi-file-excel</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Returns table -->
      <v-card flat class="table-card">
        <div class="table-responsive">
          <table class="report-table" id="content">
            <thead>
              <tr>
                <th class="text-left">#</th>
                <th>EMPLACEMENT</th>
                <th>AGENT</th>
                <th>CLIENT</th>
                <th v-if="filter_rate_id == 1">HTG</th>
                <th v-if="filter_rate_id == 2">USD</th>
                <th v-if="filter_rate_id == 3">HTG</th>
                <th v-if="filter_rate_id == 3">USD</th>
                <th>PRODUITS</th>
                <th>DATE</th>
                <th>STATUT</th>
                <th></th>
              </tr>
              <tr class="totals-row">
                <th colspan="4" class="text-left">TOTAL ({{ rows.length }} retours)</th>
                <th v-if="filter_rate_id == 1">{{ total(1) | formatNumber }}</th>
                <th v-if="filter_rate_id == 2">{{ total(2) | formatNumber }}</th>
                <th v-if="filter_rate_id == 3">{{ total(3) | formatNumber }}</th>
                <th v-if="filter_rate_id == 3">{{ total(4) | formatNumber }}</th>
                <th>{{ products() }}</th>
                <th colspan="3"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="sale in rows" :key="sale.id">
                <td class="text-left">{{ sale.sale_number }}</td>
                <td>{{ sale.store.name }}</td>
                <td>{{ sale.user.full_name }}</td>
                <td>{{ sale.customer.full_name }}</td>
                <td v-if="filter_rate_id == 1">
                  <span class="return-amount" v-if="sale.rate_id == 1">{{ Math.abs(sale.total) | formatNumber }}</span>
                  <span class="return-amount" v-if="sale.rate_id == 2">{{ Math.abs(sale.total * sale.daily_rate) | formatNumber }}</span>
                </td>
                <td v-if="filter_rate_id == 2">
                  <span class="return-amount" v-if="sale.rate_id == 2">{{ Math.abs(sale.total) | formatNumber }}</span>
                  <span class="return-amount" v-if="sale.rate_id == 1">{{ Math.abs(sale.total / sale.daily_rate) | formatNumber }}</span>
                </td>
                <td v-if="filter_rate_id == 3"><span class="return-amount" v-if="sale.rate_id == 1">{{ Math.abs(sale.total) | formatNumber }}</span></td>
                <td v-if="filter_rate_id == 3"><span class="return-amount" v-if="sale.rate_id == 2">{{ Math.abs(sale.total) | formatNumber }}</span></td>
                <td>
                  <v-chip x-small color="secondary" dark>{{ detailProducts(sale.sale_products) }}</v-chip>
                </td>
                <td class="text-caption">{{ sale.created_at | formatDate }} {{ sale.created_at | formatTime }}</td>
                <td>
                  <v-chip x-small :color="sale.status == 1 ? 'success' : 'error'" dark>
                    {{ sale.status == 1 ? 'Actif' : 'Annulé' }}
                  </v-chip>
                </td>
                <td>
                  <v-btn icon x-small @click="view(sale.id)">
                    <v-icon small color="secondary">mdi-eye-outline</v-icon>
                  </v-btn>
                </td>
              </tr>
              <tr v-if="rows.length === 0">
                <td :colspan="filter_rate_id == 3 ? 12 : 11" class="text-center text--secondary pa-6">
                  Aucun retour trouvé pour cette période
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import BreadcrumbComponent from '../components/BreadcrumbComponent.vue'
import PreloaderComponent from '../components/PreloaderComponent.vue'
import { exportReportPDF, exportReportExcel } from '@/utils/reportExport'

export default {
  name: 'ReturnsReportView',
  components: { BreadcrumbComponent, PreloaderComponent },
  data: () => ({
    items: [{ text: 'Rapport Retours', disabled: false, href: '/returns' }],
    filter_rate_id: 1,
    rows: [],
    stores: [],
    enable: false,
    loading: false,
    store_id: '',
    sale_number: '',
    business_id: 0,
    user_id: '',
    users: [],
    status: '',
    statuses: [{ id: 1, label: 'Actif' }, { id: 0, label: 'Annulé' }]
  }),
  methods: {
    load() {
      const isValid = (val) => val && val !== 'null' && val.trim() !== ''
      const debutRaw = isValid(localStorage.debut_periode.toLocaleString()) ? localStorage.debut_periode.toLocaleString() : ''
      const finRaw = isValid(localStorage.fin_periode.toLocaleString()) ? localStorage.fin_periode.toLocaleString() : ''
      var params = ''
      if (isValid(debutRaw) && isValid(finRaw)) params += '&from=' + debutRaw + '&to=' + finRaw

      var self = this
      this.$axios.get('/sales?orderdesc=created_at&include=user,store,customer,sale_products' + params)
        .then(function (response) {
          self.rows = response.data.filter(function(s) { return parseFloat(s.total) < 0 })
          self.enable = true
        })
    },
    detailProducts(products) {
      return products.reduce(function(total, p) { return total + Math.abs(parseInt(p.quantity)) }, 0)
    },
    view(id) { this.$router.push('/sales/' + id) },
    reset() { this.store_id = ''; this.sale_number = ''; this.user_id = ''; this.status = ''; this.filter() },
    total(rate_id) {
      var total = 0
      for (var i = this.rows.length - 1; i >= 0; i--) {
        if (this.rows[i].status == 1) {
          if (rate_id == 1) {
            total += this.rows[i].rate_id == 1 ? Math.abs(parseFloat(this.rows[i].total)) : Math.abs(parseFloat(this.rows[i].total)) * parseFloat(this.rows[i].daily_rate)
          } else if (rate_id == 2) {
            total += this.rows[i].rate_id == 2 ? Math.abs(parseFloat(this.rows[i].total)) : Math.abs(parseFloat(this.rows[i].total)) / parseFloat(this.rows[i].daily_rate)
          } else if (rate_id == 3) {
            if (this.rows[i].rate_id == 1) total += Math.abs(parseFloat(this.rows[i].total))
          } else {
            if (this.rows[i].rate_id == 2) total += Math.abs(parseFloat(this.rows[i].total))
          }
        }
      }
      return total
    },
    filter() {
      const isValid = (val) => val && val !== 'null' && val.trim() !== ''
      const debutRaw = isValid(localStorage.debut_periode.toLocaleString()) ? localStorage.debut_periode.toLocaleString() : ''
      const finRaw = isValid(localStorage.fin_periode.toLocaleString()) ? localStorage.fin_periode.toLocaleString() : ''
      var params = ''
      if (isValid(debutRaw) && isValid(finRaw)) params += '&from=' + debutRaw + '&to=' + finRaw
      if (this.store_id) params += '&store_id=' + this.store_id
      if (this.sale_number) params += '&sale_number=' + this.sale_number
      if (this.user_id) params += '&user_id=' + this.user_id
      if (this.status === 0 || this.status === 1) params += '&status=' + this.status

      this.enable = false
      var self = this
      this.$axios.get('/sales?orderdesc=created_at&include=user,store,customer,sale_products' + params)
        .then(function (response) {
          self.rows = response.data.filter(function(s) { return parseFloat(s.total) < 0 })
          self.enable = true
        })
    },
    async exportPDF() {
      await exportReportPDF(this.rows, this.filter_rate_id, {
        title: 'Rapport de Retours',
        headerColor: [245, 132, 59],
        filename: 'rapport_retours.pdf',
      })
    },
    exportExcel() {
      exportReportExcel(this.rows, this.filter_rate_id, {
        title: 'Retours',
        headerColorHex: 'F5843B',
        filename: 'rapport_retours.xlsx',
      })
    },
    products() {
      var products = 0
      for (var i = this.rows.length - 1; i >= 0; i--) {
        if (this.rows[i].status == 1) {
          for (var j = this.rows[i].sale_products.length - 1; j >= 0; j--) {
            products += Math.abs(parseFloat(this.rows[i].sale_products[j].quantity))
          }
        }
      }
      return products
    },
    async getStores() {
      this.business_id = JSON.parse(localStorage.business).id
      var self = this
      await this.$axios.get('/stores?orderasc=name&business_id=' + this.business_id).then(function (response) { self.stores = response.data })
    },
    async getUsers() {
      var self = this
      await this.$axios.get('/users').then(function (response) { self.users = response.data })
    },
  },
  created() {
    this.filter_rate_id = localStorage.filter_rate_id
    this.load()
    this.getUsers()
    this.getStores()
  },
}
</script>

<style scoped>
.filter-card {
  border: 1px solid #e8ecf1 !important;
  border-radius: 8px !important;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04) !important;
}

.table-card {
  border: 1px solid #e8ecf1 !important;
  border-radius: 8px !important;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04) !important;
  overflow: hidden;
}

.table-responsive {
  overflow-x: auto;
  max-height: 600px;
  overflow-y: auto;
}

.report-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8125rem;
}

.report-table thead th {
  position: sticky;
  top: 0;
  background: #f8fafc;
  font-weight: 600;
  font-size: 0.6875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  padding: 12px;
  text-align: center;
  border-bottom: 2px solid #e8ecf1;
  white-space: nowrap;
  z-index: 1;
}

.report-table .totals-row th {
  background: #fff7ed;
  color: #9a3412;
  font-weight: 700;
  font-size: 0.75rem;
  border-bottom: 2px solid #fed7aa;
}

.report-table tbody td {
  padding: 10px 12px;
  text-align: center;
  border-bottom: 1px solid #f1f5f9;
  white-space: nowrap;
}

.report-table tbody tr:hover {
  background-color: rgba(245, 132, 59, 0.04);
}

.return-amount {
  color: #c2410c;
  font-weight: 600;
}

.gap-2 {
  gap: 4px;
}
</style>
